import React from "react";
import { Snackbar, Alert } from "@mui/material";

const ToastNotification = ({ open, message, severity = "success", onClose, duration = 4000 }) => (
    <Snackbar
        open={open}
        autoHideDuration={duration}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
        <Alert onClose={onClose} severity={severity} variant="filled" sx={{ width: "100%" }}>
            {message}
        </Alert>
    </Snackbar>
);

export default ToastNotification;
